import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { IconCircleCheckFilled } from '@calendly/ui/components/glyphs/IconCircleCheckFilled';
import { AiSparkleIcon } from '@calendly/ui/components/icons';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorIconSuccess } from '@calendly/ui/theme';
import classNames from 'classnames';
const modalOuterCss = "m1r1o10r";
const sectionCss = "s1gi2p0e";
export const gradientSectionCss = "gtgukfq";
const modalSectionDividerCss = "mgcxlkm";
const standaloneOuterCss = "sz7fjdl";
const headerRowCss = "h1izjlji";
const titleRowCss = "tgakffo";
const switchLabelCss = "s1wmin9r";
const titleIconCss = "tyzc7fm";
const EnabledTitleIcon = () => <span className={titleIconCss} data-testid="notetaker-enablement-check-icon">
    <UiIcon icon={IconCircleCheckFilled} color={colorIconSuccess} size="small" title="" />
  </span>;
const DefaultTitleIcon = () => <AiSparkleIcon />;
const hasGradientVariant = variant => variant === 'enabled' || variant === 'reengagement';
const NotetakerEnablementSection = ({
  checked,
  disabled = false,
  onToggle,
  inSettingsModal = false,
  embedded = false,
  title,
  description,
  variant = 'default',
  'data-testid': dataTestId = 'notetaker-enablement-section'
}) => {
  const TitleIcon = variant === 'enabled' ? EnabledTitleIcon : DefaultTitleIcon;
  const section = <section className={classNames(sectionCss, {
    [gradientSectionCss]: hasGradientVariant(variant)
  })} data-testid={dataTestId} data-variant={variant}>
      <div className={headerRowCss}>
        <div className={titleRowCss}>
          <TitleIcon />
          <TitleText size="small" weight="bold">
            {title}
          </TitleText>
        </div>
        <label className={switchLabelCss}>
          <SwitchInput role="switch" checked={checked} disabled={disabled} onChange={onToggle} aria-label={title} data-testid="notetaker-enablement-switch" />
        </label>
      </div>
      <BodyText color="muted" size="medium">
        {HtmlParser(description)}
      </BodyText>
    </section>;
  if (embedded) {
    return section;
  }
  return <div className={classNames({
    [modalOuterCss]: inSettingsModal,
    [standaloneOuterCss]: !inSettingsModal,
    [modalSectionDividerCss]: inSettingsModal && variant !== 'reengagement'
  })}>
      {section}
    </div>;
};
export const NotetakerEnabledEnablementSection = props => <NotetakerEnablementSection {...props} variant="enabled" title={I18n.t('publisher.personal_settings.meeting_recaps.enablement.enabled_title')} description={I18n.t('publisher.personal_settings.meeting_recaps.enablement.enabled_description')} />;
export const NotetakerDisabledEnablementSection = ({
  wasPreviouslyEnabled,
  embedded = false,
  ...props
}) => <NotetakerEnablementSection {...props} checked={false} embedded={embedded} variant={wasPreviouslyEnabled ? 'reengagement' : 'default'} title={wasPreviouslyEnabled ? I18n.t('publisher.personal_settings.meeting_recaps.enablement.disabled_title') : I18n.t('publisher.personal_settings.meeting_recaps.enablement.first_time_title')} description={I18n.t('publisher.personal_settings.meeting_recaps.enablement.disabled_description')} />;

require("./notetaker_enablement_section.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./notetaker_enablement_section.js");